import { hotelService } from "@/services/hotel-service";
import { useQuery } from "@tanstack/react-query";
import { useLayoutRole } from "@/hooks/useLayoutRole";
import { useSelectedHotelId } from "@/utils/hotelContext";

export const useHotel = (enabled = true) => {
  const layoutRole = useLayoutRole();
  const isHotelScopedRole = layoutRole === "HOTEL_SCOPED";
  const selectedHotelId = useSelectedHotelId();

  const {
    data: hotel,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["userHotel", selectedHotelId],
    queryFn: async () =>
      hotelService.getUserHotel(selectedHotelId ?? undefined),
    enabled: enabled && isHotelScopedRole,
  });

  const isEnabled = hotel?.isEnabled ?? hotel?.isActive;
  const activeHotel = isEnabled === false ? null : hotel;

  return {
    // Use the selector value immediately so hotel-scoped queries switch their
    // cache keys and request paths without waiting for /user-hotel to resolve.
    hotelId: isHotelScopedRole
      ? (selectedHotelId ?? activeHotel?.id)
      : activeHotel?.id,
    hotel: activeHotel,
    isLoading,
    error,
  };
};
